'use strict';

var React = require('react');
var helpers = require('./helpers-BjcsXRdQ.js');
var styled = require('styled-components');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const PriceContainer = styled__default.default("div")(({ isDiscountedPrice }) => (Object.assign({ minWidth: "45px", textAlign: "right", minHeight: "32px" }, (isDiscountedPrice && {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
}))));
const StyledDiscountedText = styled__default.default(Text.Text) `
    text-decoration: line-through;
    opacity: 0.7;
`;
const StyledText = styled__default.default(Text.Text)(({ theme, isDiscountedPrice }) => (Object.assign({}, (!isDiscountedPrice && {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing.xSmall,
}))));

const isDiscountedPrice = (price, finalPrice) => {
    if (!finalPrice || !price) {
        return false;
    }
    return finalPrice < price;
};
const ItemPrice = ({ price, finalPrice }) => {
    return (React__default.default.createElement(PriceContainer, { isDiscountedPrice: isDiscountedPrice(price, finalPrice) },
        isDiscountedPrice(price, finalPrice) && (React__default.default.createElement(StyledDiscountedText, { variant: "V2.caption.neutral.medium", color: "text_High_Emphasis" }, `₹${helpers.priceInRupee(price)}`)),
        React__default.default.createElement(StyledText, { variant: "V2.body2.neutral.regular", color: "text_High_Emphasis", isDiscountedPrice: isDiscountedPrice(price, finalPrice) }, `₹${helpers.priceInRupee(finalPrice)}`)));
};
var ItemPrice$1 = React.memo(ItemPrice);

exports.ItemPrice = ItemPrice$1;
//# sourceMappingURL=ItemPrice-BSDHM3Zk.js.map
